import { newNotification } from 'actions/ui/ui';
import { INTERNAL_SERVER_FAILURE } from 'constants/auth';
import {
  DELETE_FILE_SUCCESS,
  UPLOAD_DOCUMENT_MAX_FILES_FAILURE,
} from 'constants/documents';
import { UPLOAD_REFUND_KYC_DOCUMENT_FAILURE } from 'constants/kycs';
import {
  CANCEL_PAYMENT_SUCCESS,
  UPDATE_PAYMENT_SUCCESS,
  UPLOAD_DOCUMENT_FAILURE,
  UPLOAD_DOCUMENT_SUCCESS,
  UPLOAD_LRS_SUCCESS,
} from 'constants/payment';
import {
  DELETE_PROOF_FILE_SUCCESS,
  UPLOAD_PROOF_SUCCESS,
} from 'constants/proofs';
import {
  CANCEL_RECURRING_RECEIVABLE_SUCCESS,
  CREATE_RECURRING_RECEIVABLE_SUCCESS,
} from 'constants/recurringReceivables';
import { UPDATE_SMS_NOTIFICATION_SUCCESS } from 'constants/smsNotifications';
import { SAVED_SUCCESSFULLY } from 'constants/ui';
import {
  CHANGE_USER_PASSWORD_SUCCESS,
  REMOVE_CREDIT_CARD_FAILURE,
  REMOVE_CREDIT_CARD_SUCCESS,
  SAVE_CARD_SUCCESS,
  UPDATE_USER_SUCCESS,
} from 'constants/user';
import type { RootState } from 'reducers/types';
import type { Middleware } from 'redux';

const isError = (type: string) => type.includes('FAILURE');

const UINotifications: Middleware<unknown, RootState> =
  store => next => action => {
    const { type, payload } = action;
    const listenedActions = [
      CANCEL_PAYMENT_SUCCESS,
      CANCEL_RECURRING_RECEIVABLE_SUCCESS,
      CHANGE_USER_PASSWORD_SUCCESS,
      DELETE_FILE_SUCCESS,
      DELETE_PROOF_FILE_SUCCESS,
      INTERNAL_SERVER_FAILURE,
      REMOVE_CREDIT_CARD_FAILURE,
      REMOVE_CREDIT_CARD_SUCCESS,
      SAVE_CARD_SUCCESS,
      SAVED_SUCCESSFULLY,
      UPDATE_PAYMENT_SUCCESS,
      UPDATE_SMS_NOTIFICATION_SUCCESS,
      UPDATE_USER_SUCCESS,
      UPLOAD_DOCUMENT_FAILURE,
      UPLOAD_DOCUMENT_MAX_FILES_FAILURE,
      UPLOAD_LRS_SUCCESS,
      UPLOAD_PROOF_SUCCESS,
      UPLOAD_REFUND_KYC_DOCUMENT_FAILURE,
      CREATE_RECURRING_RECEIVABLE_SUCCESS,
      UPLOAD_DOCUMENT_SUCCESS,
    ];

    if (listenedActions.includes(type)) {
      const message = `notifications.${type.toLowerCase()}`;
      let notificationType: 'success' | 'error' | 'info' = 'success';

      if (isError(type)) {
        notificationType = 'error';
      }

      store.dispatch(
        newNotification({ message, opts: payload, type: notificationType }),
      );
    }

    return next(action);
  };

export { UINotifications };
